export default __webpack_public_path__ + "static/media/crop_type_potato.7ab3bce6.jpg";